import gql from 'graphql-tag'
import projectFragment from '../fragments/project'

export default gql`query project($project_id: String!){
  project(project_id: $project_id){
    ${projectFragment}
  }

}`